import type * as React from 'react';
import type { FC, ReactNode } from 'react';
import { Box, List, Paper, Step, StepLabel, Stepper, Typography } from '@mui/material';
import StepperLinkItem from './StepperLinkItem';
// import { Facebook as FacebookIcon } from '@mui/icons-material';
import FacebookIcon from 'assets/icon-meta.svg?react';
// import IconTikTok from 'assets/tiktok-svg.svg?react';
import IconTikTok from 'assets/icon-tiktok.svg?react';

export interface StepType {
  title: string;
  component: React.ComponentType;
}

export interface StepperPaperProps {
  title?: string;
  steps: StepType[];
  activeStep: number;
  children?: ReactNode;
}

const StepperPaper: FC<StepperPaperProps> = ({ title, steps, activeStep, children }) => {
  return (
    <>
      <List sx={{
        '&': {
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'start',
          flexDirection: 'row',
          width: '100%',
          mb: -2,
        },
      }}>
        <StepperLinkItem
          to={`/services/facebook`}
          title="Facebook Ads"
          icon={<FacebookIcon style={{ fontSize: 24, padding: 0 }} />}
          style={{ width: 'auto', paddingBottom: 4 }}
        />
        <StepperLinkItem
          to={`/services/tiktok`}
          title="TikTok Ads"
          icon={<IconTikTok width={20} height={24} />}
          style={{ width: 'auto', paddingBottom: 4 }}
        />
      </List>
      <Box sx={{ flex: 1 }}>
        <Paper
          variant="outlined"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            pt: { xs: 2, md: 3 },
            px: { xs: 2, md: 3 },
            border: 'none',
            borderRadius: '8px',
            maxHeight: '85vh',
            overflow: 'hidden',
            overflowY: 'auto',
            boxShadow: '12px 13px 26px 5px rgb(163 145 203 / 6%)',
          }}
        >
          {title && (
            <Box sx={{ display: 'flex' }}>
              <Typography component="h1" variant="h6" align="left">
                {title}
              </Typography>
            </Box>
          )}
          <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5, '& .MuiStepIcon-text': { fontSize: '0.975rem' } }}>
            {steps.map((step) => (
              <Step key={step.title}>
                <StepLabel>{step.title}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {children}
        </Paper>
      </Box>
    </>
  );
};

export default StepperPaper;